import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-carrito-modal',
  templateUrl: './carrito-modal.component.html',
  styleUrls: ['./carrito-modal.component.css']
})
export class CarritoModalComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
